@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .rect {
    fill: var(--background-soft);
    opacity: 0.9;
    stroke: none;
  }

  .text {
    fill: currentColor;
    @include typography-v2-body-sm;
  }

  .groupSelected {
    .rect {
      fill: currentColor;
      opacity: 0.9;
    }

    .text {
      fill: var(--background-soft);
    }
  }
}
